export {ContestModule} from './core/contest.module';
export {ContestService} from './core/services/contest.service';